var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',_vm._g(_vm._b({staticClass:"input-rating"},'v-input',_vm.$attrs,false),_vm.$listeners),[_c('v-rating',{attrs:{"dense":"","small":"","color":"amber","background-color":"amber","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }